import { AirHandlerTypeCodeType } from '@alpinehomeair/common';
import { SpaceType } from 'data/types';
import { nanoid } from 'nanoid';

const AIR_HANDLER_INSET_FT = 1;

export function defaultAirHandlerPosition(space: SpaceType): {
  positionX: number;
  positionY: number;
} {
  return {
    positionX: (space.position?.x ?? 0) + AIR_HANDLER_INSET_FT,
    positionY: (space.position?.y ?? 0) + AIR_HANDLER_INSET_FT
  };
}

export function createHybridZoneAirHandler(
  space: SpaceType,
  airHandlerTypeCode: AirHandlerTypeCodeType
) {
  const { positionX, positionY } = defaultAirHandlerPosition(space);
  return {
    uniqueId: nanoid(5),
    airHandlerTypeCode,
    positionX,
    positionY,
    valid: true,
    errorMessage: null,
    warningMessage: null,
    modified: false
  };
}
